import { Button } from "@windmill/react-ui";
import React from "react";
import Logo from "../logo/Logo";

export default function NewWorkspaceWelcome({ setStep }) {
  return (
    <div className="p-6 lg:p-0 bg-green-50 min-h-screen">
      <div className="flex justify-between items-center lg:mx-24 mt-4 mb-2">
        <Logo />
      </div>
      <div className="flex flex-col justify-between max-w-xl mx-auto">
        <div className="text-center">
          {/* SVG Animation */}
          <div className="flex text-lg lg:w-8/12 justify-center mx-auto mb-8 lg:mb-0">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 800 600"
              width="100%"
              height="100%"
            >
              {/* Background circles */}
              <g transform="translate(400, 300)">
                <circle
                  cx="0"
                  cy="0"
                  r="200"
                  fill="none"
                  stroke="#e5e7eb"
                  strokeWidth="1"
                  strokeDasharray="3,3"
                  opacity="0.4"
                />
                <circle
                  cx="0"
                  cy="0"
                  r="150"
                  fill="none"
                  stroke="#e5e7eb"
                  strokeWidth="1"
                  strokeDasharray="3,3"
                  opacity="0.5"
                />
                <circle
                  cx="0"
                  cy="0"
                  r="100"
                  fill="none"
                  stroke="#e5e7eb"
                  strokeWidth="1"
                  strokeDasharray="3,3"
                  opacity="0.6"
                />
              </g>

              {/* Central database */}
              <g transform="translate(400, 300)">
                <g>
                  <ellipse cx="0" cy="25" rx="40" ry="15" fill="#2563eb" />
                  <rect x="-40" y="-5" width="80" height="30" fill="#2563eb" />
                  <ellipse cx="0" cy="-5" rx="40" ry="15" fill="#3b82f6" />
                  <ellipse cx="-5" cy="-5" rx="25" ry="8" fill="#60a5fa" />

                  {/* Database records */}
                  <rect
                    x="-20"
                    y="0"
                    width="40"
                    height="2"
                    fill="#dbeafe"
                    rx="1"
                  />
                  <rect
                    x="-20"
                    y="5"
                    width="40"
                    height="2"
                    fill="#dbeafe"
                    rx="1"
                  />
                  <rect
                    x="-20"
                    y="10"
                    width="40"
                    height="2"
                    fill="#dbeafe"
                    rx="1"
                  />
                </g>

                {/* Network node */}
                <g transform="translate(0, -40) scale(0.7)">
                  <path
                    d="M0,-30 Q-40,-25 -40,5 Q-40,35 0,40 Q40,35 40,5 Q40,-25 0,-30 Z"
                    fill="#6366f1"
                    fillOpacity="0.75"
                    stroke="#4f46e5"
                    strokeWidth="1.5"
                  />

                  {/* Connection lines */}
                  <path
                    d="M-25,-15 L-25,-8 L-15,-8 L-15,0 L-5,0 L-5,8 L0,8 L0,15 L8,15"
                    fill="none"
                    stroke="#c7d2fe"
                    strokeWidth="1.5"
                  />
                  <path
                    d="M25,-15 L25,-8 L15,-8 L15,0 L5,0 L5,8"
                    fill="none"
                    stroke="#c7d2fe"
                    strokeWidth="1.5"
                  />
                  <path
                    d="M-15,-20 L-5,-20 L-5,-12 L0,-12 L0,-4 L5,-4"
                    fill="none"
                    stroke="#c7d2fe"
                    strokeWidth="1.5"
                  />

                  {/* Network nodes */}
                  <circle cx="-20" cy="-8" r="3" fill="#e0e7ff" />
                  <circle cx="-5" cy="4" r="3" fill="#e0e7ff" />
                  <circle cx="10" cy="-4" r="3" fill="#e0e7ff" />
                  <circle cx="20" cy="10" r="3" fill="#e0e7ff" />
                  <circle cx="0" cy="20" r="3" fill="#e0e7ff" />
                  <circle cx="-20" cy="15" r="3" fill="#e0e7ff" />

                  {/* Connection paths */}
                  <line
                    x1="-20"
                    y1="-8"
                    x2="-5"
                    y2="4"
                    stroke="#c7d2fe"
                    strokeWidth="1.5"
                  />
                  <line
                    x1="-5"
                    y1="4"
                    x2="10"
                    y2="-4"
                    stroke="#c7d2fe"
                    strokeWidth="1.5"
                  />
                  <line
                    x1="10"
                    y1="-4"
                    x2="20"
                    y2="10"
                    stroke="#c7d2fe"
                    strokeWidth="1.5"
                  />
                  <line
                    x1="20"
                    y1="10"
                    x2="0"
                    y2="20"
                    stroke="#c7d2fe"
                    strokeWidth="1.5"
                  />
                  <line
                    x1="0"
                    y1="20"
                    x2="-20"
                    y2="15"
                    stroke="#c7d2fe"
                    strokeWidth="1.5"
                  />
                  <line
                    x1="-20"
                    y1="15"
                    x2="-5"
                    y2="4"
                    stroke="#c7d2fe"
                    strokeWidth="1.5"
                  />
                </g>

                {/* Orbiting elements */}
                <circle
                  cx="0"
                  cy="-90"
                  r="25"
                  fill="#e5e7eb"
                  stroke="#d1d5db"
                  strokeWidth="1"
                >
                  <animateTransform
                    attributeName="transform"
                    type="rotate"
                    from="0 0 0"
                    to="360 0 0"
                    dur="60s"
                    repeatCount="indefinite"
                  />
                </circle>

                <circle
                  cx="0"
                  cy="-90"
                  r="25"
                  fill="#e5e7eb"
                  stroke="#d1d5db"
                  strokeWidth="1"
                  opacity="0.7"
                >
                  <animateTransform
                    attributeName="transform"
                    type="rotate"
                    from="72 0 0"
                    to="432 0 0"
                    dur="45s"
                    repeatCount="indefinite"
                  />
                </circle>

                <circle
                  cx="0"
                  cy="-90"
                  r="25"
                  fill="#e5e7eb"
                  stroke="#d1d5db"
                  strokeWidth="1"
                  opacity="0.4"
                >
                  <animateTransform
                    attributeName="transform"
                    type="rotate"
                    from="144 0 0"
                    to="504 0 0"
                    dur="50s"
                    repeatCount="indefinite"
                  />
                </circle>

                <circle
                  cx="0"
                  cy="-90"
                  r="25"
                  fill="#e5e7eb"
                  stroke="#d1d5db"
                  strokeWidth="1"
                  opacity="0.6"
                >
                  <animateTransform
                    attributeName="transform"
                    type="rotate"
                    from="216 0 0"
                    to="576 0 0"
                    dur="55s"
                    repeatCount="indefinite"
                  />
                </circle>

                {/* Binary code */}
                <g opacity="0.7">
                  <text
                    x="-40"
                    y="-60"
                    fontFamily="monospace"
                    fontSize="8"
                    fill="#60a5fa"
                  >
                    10110
                  </text>
                  <text
                    x="20"
                    y="-50"
                    fontFamily="monospace"
                    fontSize="8"
                    fill="#60a5fa"
                  >
                    01001
                  </text>
                  <text
                    x="30"
                    y="-20"
                    fontFamily="monospace"
                    fontSize="8"
                    fill="#60a5fa"
                  >
                    11010
                  </text>
                  <text
                    x="-50"
                    y="-30"
                    fontFamily="monospace"
                    fontSize="8"
                    fill="#60a5fa"
                  >
                    00111
                  </text>
                  <text
                    x="20"
                    y="25"
                    fontFamily="monospace"
                    fontSize="8"
                    fill="#60a5fa"
                  >
                    10010
                  </text>
                  <text
                    x="-40"
                    y="15"
                    fontFamily="monospace"
                    fontSize="8"
                    fill="#60a5fa"
                  >
                    01101
                  </text>
                </g>

                {/* Glow effect */}
                <circle cx="0" cy="0" r="50" fill="url(#glow)" opacity="0.5">
                  <animate
                    attributeName="opacity"
                    values="0.3;0.5;0.3"
                    dur="3s"
                    repeatCount="indefinite"
                  />
                  <animate
                    attributeName="r"
                    values="50;55;50"
                    dur="6s"
                    repeatCount="indefinite"
                  />
                </circle>
              </g>

              {/* Gradient definition */}
              <defs>
                <radialGradient
                  id="glow"
                  cx="0.5"
                  cy="0.5"
                  r="0.5"
                  fx="0.5"
                  fy="0.5"
                >
                  <stop offset="0%" stopColor="#c7d2fe" stopOpacity="0.6" />
                  <stop offset="40%" stopColor="#6366f1" stopOpacity="0.3" />
                  <stop offset="100%" stopColor="#2563eb" stopOpacity="0" />
                </radialGradient>
              </defs>

              {/* Data visualization elements */}
              <g transform="translate(400, 300)">
                {/* Pie chart */}
                <g transform="rotate(0) translate(0, -180) scale(0.7)">
                  <circle
                    cx="0"
                    cy="0"
                    r="40"
                    fill="#f3f4f6"
                    stroke="#d1d5db"
                    strokeWidth="2"
                  />
                  <path d="M0,0 L30,0 A30,30 0 0,1 21,21 z" fill="#e34c67" />
                  <path d="M0,0 L21,21 A30,30 0 0,1 -21,21 z" fill="#ec6b85" />
                  <path d="M0,0 L-21,21 A30,30 0 0,1 -30,0 z" fill="#f48ba5" />
                  <path d="M0,0 L-30,0 A30,30 0 0,1 0,-30 z" fill="#f9b0c3" />
                  <path d="M0,0 L0,-30 A30,30 0 0,1 30,0 z" fill="#fcd5e1" />
                </g>

                {/* Bar chart */}
                <g transform="rotate(72) translate(0, -180) scale(0.7)">
                  <rect
                    x="-40"
                    y="-40"
                    width="80"
                    height="80"
                    fill="#f3f4f6"
                    stroke="#d1d5db"
                    strokeWidth="2"
                    rx="5"
                    ry="5"
                  />
                  <rect
                    x="-30"
                    y="10"
                    width="12"
                    height="25"
                    fill="#35b779"
                    rx="2"
                    ry="2"
                  />
                  <rect
                    x="-15"
                    y="-5"
                    width="12"
                    height="40"
                    fill="#5dc998"
                    rx="2"
                    ry="2"
                  />
                  <rect
                    x="0"
                    y="-20"
                    width="12"
                    height="55"
                    fill="#86dcb8"
                    rx="2"
                    ry="2"
                  />
                  <rect
                    x="15"
                    y="15"
                    width="12"
                    height="20"
                    fill="#afecd6"
                    rx="2"
                    ry="2"
                  />
                </g>

                {/* Documents icon */}
                <g transform="rotate(144) translate(0, -180) scale(0.7)">
                  <rect
                    x="-30"
                    y="-35"
                    width="60"
                    height="70"
                    fill="#f3f4f6"
                    stroke="#d1d5db"
                    strokeWidth="2"
                    rx="5"
                    ry="5"
                  />
                  <rect
                    x="-20"
                    y="-25"
                    width="40"
                    height="5"
                    fill="#4f46e5"
                    rx="1"
                    ry="1"
                  />
                  <rect
                    x="-20"
                    y="-15"
                    width="40"
                    height="5"
                    fill="#4f46e5"
                    rx="1"
                    ry="1"
                  />
                  <rect
                    x="-20"
                    y="-5"
                    width="25"
                    height="5"
                    fill="#4f46e5"
                    rx="1"
                    ry="1"
                  />
                  <rect
                    x="-20"
                    y="10"
                    width="40"
                    height="5"
                    fill="#4f46e5"
                    rx="1"
                    ry="1"
                  />
                  <rect
                    x="-20"
                    y="20"
                    width="30"
                    height="5"
                    fill="#4f46e5"
                    rx="1"
                    ry="1"
                  />
                </g>

                {/* Team icon */}
                <g transform="rotate(216) translate(0, -180) scale(0.7)">
                  <circle
                    cx="0"
                    cy="0"
                    r="40"
                    fill="#f3f4f6"
                    stroke="#d1d5db"
                    strokeWidth="2"
                  />
                  <circle cx="-15" cy="-5" r="12" fill="#0891b2" />
                  <circle cx="15" cy="-5" r="12" fill="#0891b2" />
                  <circle cx="0" cy="20" r="12" fill="#0891b2" />
                  <path
                    d="M-15,-5 L-5,10 L5,10 L15,-5"
                    fill="none"
                    stroke="#0891b2"
                    strokeWidth="3"
                  />
                </g>

                {/* Dashboard icon */}
                <g transform="rotate(288) translate(0, -180) scale(0.7)">
                  <rect
                    x="-35"
                    y="-35"
                    width="70"
                    height="70"
                    fill="#f3f4f6"
                    stroke="#d1d5db"
                    strokeWidth="2"
                    rx="5"
                    ry="5"
                  />
                  <rect
                    x="-25"
                    y="-25"
                    width="30"
                    height="25"
                    fill="#3b82f6"
                    rx="3"
                    ry="3"
                  />
                  <rect
                    x="10"
                    y="-25"
                    width="15"
                    height="25"
                    fill="#60a5fa"
                    rx="3"
                    ry="3"
                  />
                  <rect
                    x="-25"
                    y="5"
                    width="15"
                    height="20"
                    fill="#93c5fd"
                    rx="3"
                    ry="3"
                  />
                  <rect
                    x="-5"
                    y="5"
                    width="30"
                    height="20"
                    fill="#bfdbfe"
                    rx="3"
                    ry="3"
                  />
                </g>
              </g>

              {/* Title */}
              <text
                x="400"
                y="480"
                textAnchor="middle"
                fontFamily="Arial, sans-serif"
                fontSize="18"
                fontWeight="bold"
                fill="#3b82f6"
              >
                New Workspace
              </text>
            </svg>
          </div>

          <p className="text-green-500 font-semibold text-3xl">
            Create a New Workspace
          </p>
          <p className="max-w-lg text-sm mt-3 mx-auto">
            Let's set up a new workspace for your organization. You can create
            multiple workspaces to organize different projects, teams, or
            departments. Click continue to get started.
          </p>
        </div>

        <div className="flex justify-end border-t border-gray-200 mt-4 py-6">
          <Button
            onClick={() => {
              setStep((prev) => prev + 1);
            }}
            className="px-12"
          >
            Continue
          </Button>
        </div>
      </div>
    </div>
  );
}
